var wishlistIntent = ref({
  recipeId: null
});

/**
 * Set the wishlist intent to trigger sidebar after login
 *
 * @param {string} recipeId - ID of the recipe to show
 */
function setWishlistIntent(recipeId) {
  wishlistIntent.value = {
    recipeId: recipeId
  };
}

/**
 * Clear the wishlist intent after it's used
 */
function clearWishlistIntent() {
  wishlistIntent.value = {
    recipeId: null
  };
}
export function useWishlistSidebarIntent() {
  return {
    wishlistIntent: wishlistIntent,
    setWishlistIntent: setWishlistIntent,
    clearWishlistIntent: clearWishlistIntent
  };
}